import { SalesChannelCampaignUpdatePage } from "@/features/sales-channel-campaign/pages/SalesChannelCampaignUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/sales-channel-campaign/$id/update",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["marketplace_campaigns.edit"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCampaignUpdatePage,
});
